import { Container } from 'pixi.js';
import type { EntityType, SelectionInfo } from '@astra/shared';

/**
 * SpaceEntity - THE base class for all game entities in space.
 *
 * Provides:
 * - Unique id and entityType
 * - Lifecycle (update, destroy)
 *
 * All entities in the game extend from this class.
 */
export abstract class SpaceEntity extends Container {
  /** Unique identifier for this entity */
  abstract readonly id: string;

  /** Type discriminator (e.g., 'player', 'bot', 'asteroid', 'station') */
  abstract readonly entityType: EntityType;

  /**
   * Called every frame to update the entity.
   * @param delta - Time since last frame in milliseconds
   */
  abstract update(delta: number): void;

  /**
   * Cleanup resources when entity is removed.
   * Subclasses should call super.destroy() after their own cleanup.
   */
  destroy(): void {
    super.destroy();
  }
}
